import React, { Component } from 'react';
import _ from 'lodash';
import CollectionFeedContainer from './CollectionFeedContainer';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import {fetchCollectionFeed} from '../actions';
import striptags from 'striptags';
import sanitizeHtml from 'sanitize-html'
import download from 'helpers/downloadClipping';
import img2datauri from 'helpers/downloadClipping/img2datauri';
import config from 'config';
import moment from 'moment';
import {Button, Modal} from 'antd';
const confirm = Modal.confirm;
import { deleteCollection, setCollection , touchDownloadModal} from '../actions';
import { logAsync } from 'helpers/elogAsync';
import { fetchDownLimit } from 'modules/elog/actions';
import * as notification from 'modules/notification';
import DownloadModal from './DownloadModal';
import './style.css';

const userAgent = window.navigator.userAgent;

const container = connect(
  createSelector(
    (state) => ({
      collectionFeed: _.get(state, 'collection.clippingFeed'),
      globalIds: _.get(state, 'collection.globalIds'),
      userId: _.get(state, 'me.id'),
      dayDownLimit: _.get(state, 'elog.dayDownLimit'),
      permission: _.get(state, 'me.permission'),
    }),
    (state) => {
      return {
        ...state
      }
    }
  )
)

class CollectionLayout extends Component {

  state = {
    isDown: false,
  }

  dispatchFeedList = (action) => {
    const {dispatch} = this.props;
    dispatch(fetchCollectionFeed(action))
  }

  handleDelete = () => {
    const {dispatch, userId, globalIds} = this.props;
    confirm({
      title: '閣下確定要清空收藏夾嗎？',
      onOk() {
        dispatch(setCollection({
          type: 'REMOVE',
          userId: userId
        }))
        .then(() => {
          const {register_email} = localStorage;
          logAsync({
            type: "sPOP-remove-collection",
            data: {
              globalId: globalIds,
              user: register_email,
            }
          })
        })
      },
      onCancel() {},
    });
  }

handleModel = () => {
  const {dispatch} = this.props;
  dispatch(touchDownloadModal())
}

  render() {
    const {dispatch, globalIds, dayDownLimit, permission} = this.props;
    let downLimit = dayDownLimit;
    if (_.get(permission, 'favoriteQuota.localStorage')) {
      downLimit = parseInt(_.get(localStorage, 'downLimit', 0))
    }
    return (
      <div className='margin-left-md'  style={{background: '#fff'}}>
        <div className="subject-name margin-left-md search-title" style={{height: '47px'}}>
          <div className="pull-left">
            <span>收藏夾</span>
            <span className='count'>
              <span>(共有{_.get(globalIds, 'length')}條)</span>
            </span>
          </div>
          <div className="margin-top-md" style={{display: 'inline-block', float: 'right'}}>
            <Button
              disabled={_.get(globalIds, 'length') == 0}
              className="pull-right margin-right-md"
              type="ghost"
              loading={this.state.isDown}
              onClick={this.handleModel}>
                {this.state.isDown ? "保存中" : t('commonSave')}</Button>
            <Button disabled={_.get(globalIds, 'length') == 0} className="pull-right margin-right-md" type="ghost" onClick={this.handleDelete}>清空全部</Button>
            <span className="pull-right margin-right-md" style={{ lineHeight: '28px', fontSize: '15px'}}>今天已保存：{downLimit} 剩餘保存量：{50-downLimit}</span>
          </div>
        </div>
        {_.get(globalIds, 'length') == 0 &&
          <div className="no-globalIds">
            收藏夾暫無數據
          </div>
          ||
          <CollectionFeedContainer dispatch={this.dispatchFeedList} originDispatch={dispatch}/>
        }
        <DownloadModal />
      </div>
    )
  }
}

export default container(CollectionLayout)



/** WEBPACK FOOTER **
 ** ./src/app/modules/collection/components/CollectionLayout.js
 **/